import React, { useEffect, useMemo, useState } from 'react';
import './FileInboxSelector.scss';
import { NoOp } from '../../helpers/Utils';
import languageManager from '../../helpers/Language';
import { INBOX_LIST_IMAGE, InboxFolderList } from '../../helpers/InboxFolder';
import UserAnalytic from '../../helpers/UserAnalytic';
import { Form } from 'react-bootstrap';
import { Item } from './FileInboxSelector';

const FileBucketSelector = ({
    className = '',
    defaultInbox = 0,
    bucketList = [],
    onInboxSelected = NoOp
}) => {
    const [selectedElement, setSelectedElement] = useState(defaultInbox);
    const [currentOption, setCurrentOption] = useState({});
    const optionList = useMemo(() => {
        const optionList = {};
        if (!Array.isArray(bucketList)) return {};
        let firstCategory = null;
        for (let elm of bucketList) {
            if (!firstCategory) {
                firstCategory = elm.category;
            }
            if (!optionList[elm.category]) {
                optionList[elm.category] = [];
            }
            optionList[elm.category].push(elm);
        }
        const items = optionList[firstCategory];
        setCurrentOption({
            name: firstCategory,
            items,
        });
        return optionList;
    }, [bucketList]);
    const handleSelectElement = (bucket) => {
        setSelectedElement(bucket);
        UserAnalytic.event({
            category: 'File Selector',
            action: 'Select file',
        });
        onInboxSelected({
            ...bucket,
            isBucket: true
        });
    };
    const handleSelectCategory = (e) => {
        const name = e.target.value;
        const items = optionList[name];
        setCurrentOption({ name, items, });
        // const bucket = items[0];
        // handleSelectElement(bucket);
    };
    useEffect(() => {
        const items = currentOption.items
        handleSelectElement(items[0]);
    }, [currentOption])
    return (
        <>
            <h5 className="text-muted">{languageManager.T('DRIVE_UPLOAD_SLCT_CATEGORY')}</h5>
            <div className='mb-2'>
                <Form.Select onChange={handleSelectCategory}>
                    {Object.keys(optionList).map((key, idx) => (
                        <option key={idx} value={key}>{key}</option>
                    ))}
                </Form.Select>
            </div>
            <h5 className="text-muted">{languageManager.T('DRIVE_UPLOAD_SLCT_BUCKET')}</h5>
            <div className={"file-inbox-selector " + className}>
                {(currentOption && Array.isArray(currentOption.items) ? currentOption.items : []).map((item, idx) => (
                    <Item
                        key={idx}
                        name={languageManager.T(item.label)}
                        imgSrc={INBOX_LIST_IMAGE[item.iconLibrary] || INBOX_LIST_IMAGE.DEFAULT}
                        onClick={() => handleSelectElement(item)}
                        active={item.id === selectedElement.id}
                    />
                ))}
            </div>
        </>
    );
};

FileBucketSelector.Item = Item;

export default FileBucketSelector;
